import ComponentInterface from '../../core/component-interface';
import { toRaphaelColor, hashify, parseUnsafeString, pluck, pluckNumber, getFirstColor, BLANKSTRING } from '../../_internal/lib/lib';
import { addDep } from '../../_internal/dependency-manager';
import centerLabelAnimation from '../../_internal/animation-rules/center-label-animation';

let UNDEF,
  HIDDEN = 'hidden',
  VISIBLE = 'visible';

function replaceMacros (text, macrosArr, valuesArr) {
  if (text) {
    var i = macrosArr.length || 0,
      regExpression;
    while (i--) {
      regExpression = new RegExp(macrosArr[i], 'gi');
      text = text.replace(regExpression, valuesArr[i]);
    }
  }
  return text;
}
addDep({
  name: 'centerLabelAnimation',
  type: 'animationRule',
  extension: centerLabelAnimation
});
export default class CenterLabel extends ComponentInterface {
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'centerLabel';
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'centerLabel';
  }

  configure (config) {
    let chartAttr = this.getFromEnv('chart-attrib'),
      numberFormatter = this.getFromEnv('number-formatter'),
      dataLabelStyle = config.dataLabelStyle,
      centerLabel = this;

    centerLabel.config = {
      label: parseUnsafeString(pluck(chartAttr.defaultcenterlabel, '')),
      font: pluck(chartAttr.centerlabelfont, dataLabelStyle.fontFamily),
      fontSize: pluckNumber(chartAttr.centerlabelfontsize, parseInt(dataLabelStyle.fontSize, 10)),

      color: getFirstColor(pluck(chartAttr.centerlabelcolor, chartAttr.valuefontcolor,
        config.style.inCanvasStyle.color, '555555')),
      alpha: pluckNumber(chartAttr.centerlabelalpha, 100),

      bold: pluckNumber(chartAttr.centerlabelbold, dataLabelStyle.fontWeight),
      italic: pluckNumber(chartAttr.centerlabelitalic, dataLabelStyle.style),

      bgColor: pluck(chartAttr.centerlabelbgcolor, ''),
      bgAlpha: pluckNumber(chartAttr.centerlabelbgalpha, 100),

      borderColor: pluck(chartAttr.centerlabelbordercolor, dataLabelStyle.borderColor),
      borderAlpha: pluckNumber(chartAttr.centerlabelborderalpha, 100),

      borderThickness: pluckNumber(chartAttr.centerlabelborderthickness, dataLabelStyle.borderThickness),
      borderRadius: pluckNumber(chartAttr.centerlabelborderradius, dataLabelStyle.borderRadius),

      textPadding: pluckNumber(chartAttr.centerlabeltextpadding, dataLabelStyle.borderPadding),
      padding: pluckNumber(chartAttr.centerlabelpadding, 2),

      bgOval: pluckNumber(chartAttr.centerlabelbgoval, 0),
      shadow: pluckNumber(chartAttr.showcenterlabelshadow, 0),
      // getFirstColor(pluck(chartAttr.centerlabelhovercolor, chartAttr.centerlabelcolor, '555555')),
      hoverColor: chartAttr.centerlabelhovercolor && getFirstColor(pluck(
        chartAttr.centerlabelhovercolor)),
      hoverAlpha: pluckNumber(chartAttr.centerlabelhoveralpha),

      toolText: parseUnsafeString(pluck(chartAttr.centerlabeltooltext, BLANKSTRING))
    };

    centerLabel.addExtEventListener('datasetrollover', function (event) {
      let dataJSON = event.sender.getFromEnv('dataSource'),
        data = event.data,
        label = pluck(replaceMacros(dataJSON.chart.centerlabel,
          ['\\$value', '\\$percentValue', '\\$displayValue', '\\$label'],
          [numberFormatter.scale(data.value), data.pValue, data.displayValue, data.label]), '');
      centerLabel.draw(label, false);
    }, this.getFromEnv('chart').getDatasets()[0]);

    centerLabel.addExtEventListener('datasetrollout', function (event) {
      let centerlabel = event.sender.config.label,
        label = pluck(centerlabel, '');
      centerLabel.draw(label, false);
    }, this.getFromEnv('chart').getDatasets()[0]);
  }
  /**
   * function to draw label on given co-ordinate.
   * it may take optional label text if it is required.
   * In case of specific label text when it is needed; for example:
   * custom label text on hover on a plot we can set optional label text
   * @param  {string} labelText String to show as centerlabel
   */
  draw (labelText) {
    var centerLabel = this,
      chart = centerLabel.getFromEnv('chart'),
      cx = chart.config.canvasLeft + chart.config.canvasWidth * 0.5,
      cy = chart.config.canvasTop + chart.config.canvasHeight * 0.5,
      dx = chart.getDatasets()[0].config.innerSize,
      dy = chart.getDatasets()[0].config.innerSize,
      dataSet = chart.getDatasets()[0],
      seriesData = dataSet.config,
      labelConfig = this.config,
      animationManager = centerLabel.getFromEnv('animationManager'),
      smartLabel = centerLabel.getFromEnv('smartLabel'),
      centerLabelGraphics = this.getGraphicalElement('centerLabel'),
      centerLabelBgGraphics = this.getGraphicalElement('centerLabelBg'),
      grp = chart.getChildContainer('plotGroup'),
      labelPadding = labelConfig.padding,
      textpadding = labelConfig.textPadding * 2,
      cssObj = {
        fontFamily: labelConfig.font,
        fontSize: labelConfig.fontSize + 'px',
        lineHeight: (1.2 * labelConfig.fontSize) + 'px',
        fontWeight: labelConfig.bold ? 'bold' : '',
        fontStyle: labelConfig.italic ? 'italic' : ''
      },
      txtW = ((dx * 0.5 - labelPadding) * 1.414) - textpadding,
      txtH = ((dy * 0.5 - labelPadding) * 1.414) - textpadding,
      smartLabelObj,
      toolTipController = centerLabel.getFromEnv('toolTipController');

    labelText = pluck(labelText, labelConfig.label);
    smartLabel.setStyle(cssObj);
    smartLabel.useEllipsesOnOverflow(chart.config.useEllipsesWhenOverflow);
    smartLabelObj = smartLabel.getSmartText(labelText, txtW, txtH);
    if (!centerLabelGraphics) {
      centerLabel.addEventListener('mouseover', function () {
        centerLabel._centerLabelRollover(chart);
      });
      centerLabel.addEventListener('mouseout', function () {
        centerLabel._centerLabelRollout(chart);
      });
      centerLabel.addEventListener('click', function () {
        centerLabel._centerLabelClick(chart);
      });
    // TODO: Fix reference issue
    // centerLabelGraphics.chart = chart;
    } else {
      centerLabelGraphics.attr('text') !== labelText &&
        centerLabel.centerLabelChange(labelText);
    }

    if (labelText) {
      if (labelConfig.bgOval) {
        centerLabelBgGraphics = animationManager.setAnimation({
          el: centerLabelBgGraphics || 'circle',
          attr: {
            cx: cx,
            cy: cy,
            r: dx * 0.5 - labelPadding,
            visibility: VISIBLE,
            container: grp,
            fill: hashify(labelConfig.bgColor),
            'fill-opacity': labelConfig.bgAlpha / 100,
            stroke: hashify(labelConfig.borderColor),
            'stroke-width': labelConfig.borderThickness,
            'stroke-opacity': labelConfig.borderAlpha / 100
          },
          component: centerLabel
        });
      }
      centerLabelGraphics = animationManager.setAnimation({
        el: centerLabelGraphics || 'text',
        component: centerLabel,
        container: grp,
        css: cssObj,
        attr: {
          x: cx,
          y: cy,
          text: smartLabelObj.text,
          visibility: VISIBLE,
          direction: chart.config.textDirection,
          // title: labelConfig.toolText ? '' : smartLabelObj.tooltext || '',
          fill: toRaphaelColor({
            FCcolor: {
              color: labelConfig.color,
              alpha: labelConfig.alpha
            }
          }),
          'text-bound': labelConfig.bgOval ? 'none' : [
            toRaphaelColor({
              FCcolor: {
                color: labelConfig.bgColor,
                alpha: labelConfig.bgAlpha
              }
            }),
            toRaphaelColor({
              FCcolor: {
                color: labelConfig.borderColor,
                alpha: labelConfig.borderAlpha
              }
            }),
            labelConfig.borderThickness,
            labelConfig.textPadding,
            labelConfig.borderRadius
          ]
        },
        label: 'text'
      });
      toolTipController.enableToolTip(centerLabelGraphics, labelConfig.toolText || smartLabelObj.tooltext);
    } else {
      centerLabelGraphics && animationManager.setAnimation({
        el: centerLabelGraphics,
        attr: {'visibility': HIDDEN},
        component: centerLabel
      });
      centerLabelBgGraphics && animationManager.setAnimation({
        el: centerLabelBgGraphics,
        attr: {'visibility': HIDDEN},
        component: centerLabel
      });
    }

    centerLabel.addGraphicalElement('centerLabel', centerLabelGraphics);
    centerLabel.addGraphicalElement('centerLabelBg', centerLabelBgGraphics);
    seriesData.lastCenterLabelConfig = labelConfig;
    seriesData.centerLabelConfig = labelConfig;
  }

  /**
   * helper function to draw
   * when element is present but text is changed then this function is excuted
   * @param  {text} labelText label text
   */
  centerLabelChange (labelText) {
    let centerLabelapi = this,
      chart = centerLabelapi.getFromEnv('chart'),
      chartConfig = chart.config,
      chartInstance = centerLabelapi.getFromEnv('chartInstance'),
      eventArgs = {
        height: chartConfig.height,
        width: chartConfig.width,
        pixelHeight: chart.getFromEnv('chartWidth'),
        pixelWidth: chart.getFromEnv('chartHeight'),
        id: chartInstance.id,
        renderer: chartInstance.args.renderer,
        container: centerLabelapi.getFromEnv('chart-container'),
        centerLabelText: labelText
      };
    /**
   * This event is fired on change of label at center of doughnut 2D.
   *
   * > Available on `doughnut` chart only.
   *
   * @group chart:pie-center-label
   * @event FusionCharts#centerLabelChanged
   *
   * @param {string} centerLabelText - is the text for display at center label
   * @param {number} chartX - is the relative X-Cordinate to chart container where the chart was clicked
   * @param {number} chartY - is the relative Y-Cordinate to chart container where the chart was clicked.
   * @param {string} container - is the DOM element where the chart is being rendered.
   * @param {numeric|percent} height - height of the chart
   * @param {numeric|percent} width - width of the chart
   * @param {string} id - is the chart id
   * @param {number} pageX - is the relative X-Cordinate to screen where the chart is clicked
   * @param {number} pageY - is the relative Y-Cordinate to screen where the chart is clicked
   * @param {number} pixelHeight - is the height of the DOM element where the chart is being rendered in
   * pixels
   * @param {number} pixelWidth - is the width of the DOM element where the chart is being rendered in
   * pixels
   * @param {string} renderer - tells if the chart is rendered using JavaScript or Flash
   */
    chart.fireChartInstanceEvent('centerLabelChanged', eventArgs);
  }

  /**
   * callback function on mouse over event
   * @param {Object} chart - Takes chart object as input
   */
  _centerLabelRollover (chart) {
    let chartConfig = chart.config,
      chartInstance = chart.getFromEnv('chartInstance'),
      labelConfig = this.config,
      cLabel = this,
      eventArgs = {
        height: chartConfig.height,
        width: chartConfig.width,
        pixelHeight: chart.getFromEnv('chartWidth'),
        pixelWidth: chart.getFromEnv('chartHeight'),
        id: chartInstance.id,
        renderer: chartInstance.args.renderer,
        container: this.getFromEnv('chart-container'),
        centerLabelText: labelConfig && labelConfig.label
      };
      /**
       * This event is fired on mouse rollover on label at center of doughnut 2D.
       *
       * > Available on `doughnut` chart only.
       *
       * @group chart:pie-center-label
       * @event FusionCharts#centerLabelRollover
       *
       * @param {string} centerLabelText - is the text for display at center label
       * @param {number} chartX - is the relative X-Cordinate to chart container where the chart was clicked
       * @param {number} chartY - is the relative Y-Cordinate to chart container where the chart was clicked.
       * @param {string} container - is the DOM element where the chart is being rendered.
       * @param {numeric|percent} height - height of the chart
       * @param {numeric|percent} width - width of the chart
       * @param {string} id - is the chart id
       * @param {number} pageX - is the relative X-Cordinate to screen where the chart is clicked
       * @param {number} pageY - is the relative Y-Cordinate to screen where the chart is clicked
       * @param {number} pixelHeight - is the height of the DOM element where the chart is being rendered in
       * pixels
       * @param {number} pixelWidth - is the width of the DOM element where the chart is being rendered in
       * pixels
       * @param {string} renderer - tells if the chart is rendered using JavaScript or Flash
       */
    this.getFromEnv('paper').attr('text') && chart.fireChartInstanceEvent('centerLabelRollover',
      eventArgs, UNDEF, cLabel.hoverOnCenterLabel.bind(cLabel, chart));
  }
  /**
   * callback function on mouse out event
   * @param {Object} chart - Takes chart object as input
   */
  _centerLabelRollout (chart) {
    let chartConfig = chart.config,
      cLabel = this,
      chartInstance = chart.getFromEnv('chartInstance'),
      labelConfig = this.config,
      eventArgs = {
        height: chartConfig.height,
        width: chartConfig.width,
        pixelHeight: chart.getFromEnv('chartWidth'),
        pixelWidth: chart.getFromEnv('chartHeight'),
        id: chartInstance.id,
        renderer: chartInstance.args.renderer,
        container: this.getFromEnv('chart-container'),
        centerLabelText: labelConfig && labelConfig.label
      };
      /**
       * This event is fired on mouse rollout from label at center of
       * doughnut 2D.
       *
       * > Available on `doughnut` chart only.
       *
       * @group chart:pie-center-label
       * @event FusionCharts#centerLabelRollout
       *
       * @param {string} centerLabelText - is the text for display at center label
       * @param {number} chartX - is the relative X-Cordinate to chart container where the chart was clicked
       * @param {number} chartY - is the relative Y-Cordinate to chart container where the chart was clicked.
       * @param {string} container - is the DOM element where the chart is being rendered.
       * @param {numeric|percent} height - height of the chart
       * @param {numeric|percent} width - width of the chart
       * @param {string} id - is the chart id
       * @param {number} pageX - is the relative X-Cordinate to screen where the chart is clicked
       * @param {number} pageY - is the relative Y-Cordinate to screen where the chart is clicked
       * @param {number} pixelHeight - is the height of the DOM element where the chart is being rendered in
       * pixels
       * @param {number} pixelWidth - is the width of the DOM element where the chart is being rendered in
       * pixels
       * @param {string} renderer - tells if the chart is rendered using JavaScript or Flash
       */
    this.getFromEnv('paper').attr('text') && chart.fireChartInstanceEvent('centerLabelRollout',
      eventArgs, UNDEF, cLabel.hoverOffCenterLabel.bind(cLabel, chart));
  }
  /**
   * callback function on mouse click event
   * @param {Object} chart - Takes chart object as input
   */
  _centerLabelClick (chart) {
    let chartConfig = chart.config,
      chartInstance = chart.getFromEnv('chartInstance'),
      eventArgs = {
        height: chartConfig.height,
        width: chartConfig.width,
        pixelHeight: chart.getFromEnv('chartWidth'),
        pixelWidth: chart.getFromEnv('chartHeight'),
        id: chartInstance.id,
        renderer: chartInstance.args.renderer,
        container: this.getFromEnv('chart-container')
      },
      labelConfig;
    labelConfig = this.config;
    eventArgs.centerLabelText = labelConfig && labelConfig.label;
    /**
     * This event is fired on click on label at center of doughnut 2D.
     *
     * > Available on `doughnut` chart only.
     *
     * @group chart:pie-center-label
     * @event FusionCharts#centerLabelClick
     *
     * @param {string} centerLabelText - is the text for display at center label.
     * @param {number} chartX - is the relative X-Cordinate to chart container where the chart was clicked.
     * @param {number} chartY - is the relative Y-Cordinate to chart container where the chart was clicked.
     * @param {string} container - is the DOM element where the chart is being rendered.
     * @param {numeric|percent} height - height of the chart
     * @param {numeric|percent} width - width of the chart
     * @param {string} id - is the chart id
     * @param {number} pageX - is the relative X-Cordinate to screen where the chart is clicked
     * @param {number} pageY - is the relative Y-Cordinate to screen where the chart is clicked
     * @param {number} pixelHeight - is the height of the DOM element where the chart is being rendered in
     * pixels
     * @param {number} pixelWidth - is the width of the DOM element where the chart is being rendered in
     * pixels
     * @param {string} renderer - tells if the chart is rendered using JavaScript or Flash
     */
    this.getFromEnv('paper').attr('text') && chart.fireChartInstanceEvent('centerLabelClick',
      eventArgs);
  }
  /**
   * callback function to centerLabelRollover event
   * @param {Object} chart - Takes chart object as input
   */
  hoverOnCenterLabel (chart) {
    let dataSet = chart.getChildren('dataset')[0],
      seriesData = dataSet.config,
      labelConfig = seriesData.lastCenterLabelConfig;

    if (labelConfig.hoverColor || labelConfig.hoverAlpha) {
      this.getGraphicalElement('centerLabel').attr({fill: toRaphaelColor({
        FCcolor: {
          color: labelConfig.hoverColor || labelConfig.color,
          alpha: labelConfig.hoverAlpha || labelConfig.alpha
        }
      })
      });
    }
  }
  /**
   * callback function to centerLabelRollout event
   * @param {Object} chart - Takes chart object as input
   */
  hoverOffCenterLabel (chart) {
    let dataSet = chart.getChildren('dataset')[0],
      seriesData = dataSet.config,
      labelConfig = seriesData.lastCenterLabelConfig;

    if (labelConfig.hoverColor || labelConfig.hoverAlpha) {
      this.getGraphicalElement('centerLabel').attr({fill: toRaphaelColor({
        FCcolor: {
          color: labelConfig.color,
          alpha: labelConfig.alpha
        }
      })
      });
    }
  }
}
